import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faTrashAlt, faTimes } from '@fortawesome/free-solid-svg-icons';

const ModalEliminarMovimientos = ({ 
    show, 
    handleClose, 
    movimientosSeleccionados, 
    eliminarMovimientos, 
    cargando 
}) => {
    return (
        <Modal 
            show={show} 
            onHide={handleClose} 
            centered 
            backdrop="static"
            keyboard={false}
            dialogClassName="modal-eliminar-minimalista"
        >
            <div className="border-0 rounded-4 shadow-lg bg-white overflow-hidden">
                <Modal.Body className="p-5 text-center">
                    <div className="mb-4">
                        <div 
                            className="rounded-circle d-inline-flex align-items-center justify-content-center bg-soft-danger text-danger mb-3"
                            style={{ width: '80px', height: '80px', backgroundColor: '#fde8e8' }}
                        >
                            <FontAwesomeIcon icon={faExclamationTriangle} size="2x" style={{ color: '#e63757' }} />
                        </div>
                        <h4 className="fw-bold text-dark mb-2">Eliminar Movimientos</h4>
                        <p className="text-500 mb-0 px-3">
                            ¿Estás seguro de que deseas eliminar <strong>{movimientosSeleccionados.length}</strong> movimiento(s) bancario(s)? Esta acción no se puede deshacer.
                        </p>
                    </div>

                    <div className="d-flex justify-content-center gap-3 mt-4">
                        <Button 
                            variant="light" 
                            className="rounded-pill px-4 fw-semi-bold border-0 bg-200 text-600 hover-bg-300"
                            onClick={handleClose}
                            disabled={cargando}
                        >
                            <FontAwesomeIcon icon={faTimes} className="me-2" />
                            Cancelar
                        </Button>
                        <Button 
                            variant="danger" 
                            className="rounded-pill px-4 fw-semi-bold shadow-sm"
                            onClick={eliminarMovimientos}
                            disabled={cargando}
                            style={{ backgroundColor: '#e63757', borderColor: '#e63757' }}
                        >
                            {cargando ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Eliminando...
                                </>
                            ) : (
                                <>
                                    <FontAwesomeIcon icon={faTrashAlt} className="me-2" />
                                    Sí, Eliminar
                                </>
                            )}
                        </Button>
                    </div>
                </Modal.Body>
            </div>
        </Modal>
    );
};

export default ModalEliminarMovimientos;
